import MainLayout from 'components/layout/MainLayout';
import BlogArticle from 'components/blog/BlogArticle';
import { ASSET_PREFIX } from 'utils/constants';
import { NextSeo } from 'next-seo';
import RoundedButton from 'components/RoundedButton';
import Separator from 'components/Separator';
import { getCta } from 'utils/common';

const Article = () => {
  const IMAGE_DIRECTORY = `${ASSET_PREFIX}/images/blog/articles/tech-prize-highlights`;

  return (
    <MainLayout>
      <NextSeo
        title="Tech Prize Highlights | DAYMADE"
        description="DAYMADE brings you the ultimate tech prize guide. And the best part? All of these gadgets and gizmos can be won in our weekly draw for the price of a coffee!"
        openGraph={{
          title: 'Tech Prize Highlights | DAYMADE',
          description:
            'DAYMADE brings you the ultimate tech prize guide. And the best part? All of these gadgets and gizmos can be won in our weekly draw for the price of a coffee!',
          type: 'article',
          url: 'https://www.daymade.co.uk/blog/tech-prize-highlights',
          images: [
            {
              url: `${IMAGE_DIRECTORY}/hero.jpg`,
              alt: 'Desk with iMac, Dyson Purifier and assorted tech',
            },
          ],
        }}
        // additionalMetaTags={[{
        //   name: 'keywords',
        //   content: 'win,tech prizes,photography,pizza oven,fitbit,dyson,hot tub,cinema,tech gadgets,macbook air,playstation 5',
        // }]}
      />

      <BlogArticle
        imageDirectory={IMAGE_DIRECTORY}
        heroAltText="Desk with iMac, Dyson Purifier and assorted tech"
      >
        <>
          <h1 style={{ fontSize: '1.6em' }}>
            Tech Prize <strong>Highlights</strong>
          </h1>

          <p className="subheading">
            25 epic tech gadgets - what would you choose?
          </p>

          <div
            className="separator"
            style={{ width: '80%', marginTop: 0 }}
          />

          <p
            style={{
              fontStyle: 'italic',
              textAlign: 'center',
              marginBottom: '2em',
            }}
          >
            by Abbi James
          </p>

          <p>
            <span className="bigFirstLetter">H</span>ere at DAYMADE, we’re big
            fans of trying the latest and greatest tech gifts and gadgets.
            Whether you want the low-down on the best tech gifts 2021, or just
            some gift inspiration, we’re here with the ultimate tech prize
            guide. And the best part? All of these gadgets and gizmos can be won
            in our weekly draw for the price of a coffee!
          </p>

          <h4>Photography bundle</h4>

          <p>
            There hasn’t been a whole lot of travel this past year, but that’s
            all about to change in the coming months – freedom’s a-calling! And
            when we do finally get exploring, we want to capture our travels in
            all their glory. We know one camera isn’t perfect for every
            situation, so we’ve put our heads together to come up with what we
            think is the perfect photography and videography bundle!
          </p>

          <p>
            The Nikon Z5 mirrorless camera will capture photos packed with rich
            detail and colours, whilst being light and portable. Add to that the
            NIKKOR Z 24-50mm f/4-6.3 lens and you’re onto a winner with an
            amazing camera & lens combo.
          </p>

          <p>
            For those who love a good adventure with some great action thrown in
            for good measure, we’ve included the GoPro HERO9 bundle. This means
            you’ll get up close and personal photos and videos of your skiing,
            surfing and mountain biking with some of the best stabilisation
            available.
          </p>

          <p>
            Our final tech prize in this photography bundle is perfect for when
            you want to get aerial shots further from the action. The DJI Mini 2
            Fly More Drone Combo offers a unique perspective to upgrade your
            photography and videography in one simple package. Weighing about
            the same as an apple (no, really!), this is the perfect compact
            drone to pop in your pocket and take with you wherever, whenever.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary1.jpg`}
            alt="GoPro HERO9"
            className="singleBlogImage"
          />

          <h4>Ooni pizza oven</h4>

          <p>
            Food is the way to our hearts, and what better way than by making
            homemade pizzas with family and friends? The Ooni Pizza Oven brings
            everyone together towards one common goal – making delicious
            stone-baked pizza! This summer, we can’t wait to don the apron, pick
            the toppings and cook up a feast. Each pizza only takes 60 seconds
            to stone-bake, which leaves more time for catching up with loved
            ones in a garden party fit for a chef.
          </p>

          <h4>Fitbit Charge 4</h4>

          <p>
            Lockdown has left many of us going from bed to desk to sofa, on
            repeat. Hands up if that’s you (and if not, we know you’re lying)!
            Our team here at DAYMADE have decided it’s time to take charge of
            our health and fitness, courtesy of the Fitbit Charge 4. It helps
            you to keep track of your heart-rate, breathing, oxygen saturation,
            sleep patterns…the list goes on! And for those of us that need a
            cheat-day every now and then, it doubles as a stylish watch too.
          </p>

          <h4>Dyson bundle</h4>

          <p>
            We all know and love a Dyson, and for good reason. We’ve popped them
            on our top tech list not just for their award-winning vacuums, but
            also for their hair care range! The Dyson Airwrap styler is perfect
            for styling that I-haven’t-had-my-hair-done-in-over-a-year hair to
            give you that pep in your step as we face the outside world. The
            Dyson Supersonic hair dryer is the go-to for getting out the door in
            a flash, while the Dyson Corrale straightener uses pioneering
            technology to keep us looking fab.
          </p>

          <p>
            On top of these, you’ll also receive the Dyson v8 Animal Vacuum
            coupled with the v7 Handheld Vacuum - we couldn’t not include these
            in our bundle! You’ll also receive the Dyson Pure Purifier, Heater
            and Cooler, perfect for keeping the status quo all year round.
            Thanks Dyson!
          </p>

          <h4>Miami AirJet Hot Tub</h4>

          <p>
            Your very own hot tub….there’s really not much more that needs to be
            said! We all need our own space to relax and unwind, and that’s
            exactly what the Lay-Z-Spa Miami AirJet Hot Tub is designed for. 120
            air jets are ready to massage those muscles in no time, leaving you
            rejuvenated and refreshed (if you can ever leave the comfort of the
            bubbles, that is). We might not be blessed with baking-hot sun all
            year round, but that’s the beauty of a hot tub – it’s already hot!
            The Miami AirJet™ hot tub can seat you and up to three of your
            besties, and warm you up to a cosy 40⁰C. So even in the depths of
            winter, you’ve got no excuse not to have a little me-time.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary2.jpg`}
            alt="Miami AirJet Hot Tub"
            className="singleBlogImage"
          />

          <h4>Cinema at home</h4>

          <p>
            Just picture this: it’s summer, the BBQ’s died down, the popcorn’s
            popping and it’s show time. Here at DAYMADE, we think it’s time to
            make the most of spending time with family and friends, and that’s
            why this movie projector is on our list! Being super portable, you
            can opt to have an indoor movie sesh or a cosy outdoors gathering by
            the fire. The DR.Q HI-04 Projector comes with its own projection
            screen and supports Full HD – so you can watch your fave film the
            way it was intended be seen. Popcorn anyone..?
          </p>

          <h4>Gadgets-galore</h4>

          <p>
            Now this one might be cheating a bit. Our all-time favourite tech
            prize is here with the perfect pick ‘n’ mix for you to choose your
            go-to gadgets. After so many of us have been working from home,
            we’ve got the MacBook Air 13”, FLEXISPOT Desk Bike and Bose Noise
            Cancelling Headphones to give your home office an upgrade.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary3.jpg`}
            alt="MacBook Air"
            className="singleBlogImage"
          />

          <p>
            Following the old adage of ‘work hard, play hard’, we’re also big
            fans of the kind of tech that gives us some me-time. Get your hands
            on the Playstation 5 to cooperate with friends in It Takes Two, or
            keep your adrenaline going with Resident Evil Village. If you choose
            to win the Xbox Series X, you can compete with friends in Fifa 21 or
            live life as a Viking in Assassin’s Creed Valhalla. For those who’d
            prefer to game to relax, pick up the Nintendo Switch for the
            best-selling Animal Crossing and build your own island village!
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary4.jpg`}
            alt="Playstation 5"
            className="singleBlogImage"
          />

          <p>
            We’ve tried our very best to cover everyone’s tech needs and wants,
            but if you think of anything you’d like to see, drop us a line!
          </p>

          <p>
            £10,000 and 25 epic tech gadgets to choose from. The question is:
            what would you choose?
          </p>

          <Separator style={{ margin: '2em' }} />

          <RoundedButton
            href={getCta()?.url}
            style={{ minWidth: '180px' }}
          >
            Enter Now
          </RoundedButton>
        </>
      </BlogArticle>
    </MainLayout>
  );
};

export default Article;
